import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

const faqs = [
  {
    question: "Kampüs Mentorluk'ta koçluk süreci nasıl işliyor?",
    answer: "Koçluk sürecimiz tamamen kişiselleştirilmiş bir yaklaşımla yürütülüyor. Öncelikle hedeflerinize ve ihtiyaçlarınıza en uygun koçla eşleşiyorsunuz. Ardından koçunuzla birlikte çalışma planınızı oluşturuyor ve düzenli görüşmelerle hedeflerinize doğru ilerliyorsunuz. Her öğrencinin kendine özgü çalışma temposu ve ihtiyaçları göz önünde bulundurularak program şekillendiriliyor."
  },
  {
    question: "Koçlarınızı nasıl seçiyorsunuz?",
    answer: "Koçlarımız, Türkiye'nin en prestijli üniversitelerinde okuyan veya mezun olmuş, kendi alanlarında üstün başarı göstermiş öğrenciler arasından özenle seçiliyor. Seçim sürecinde akademik başarılarının yanı sıra iletişim becerileri, mentorluk yetenekleri ve öğretme konusundaki istekleri de değerlendiriliyor."
  },
  {
    question: "Hangi alanlarda koçluk hizmeti veriyorsunuz?",
    answer: "Sayısal (SAY), Eşit Ağırlık (EA), Sözel (SÖZ) ve Dil alanlarında koçluk hizmeti sunuyoruz. Her alanda, ilgili bölümlere yerleşmiş ve yüksek başarı göstermiş koçlarımız bulunmaktadır."
  },
  {
    question: "Online koçluk sistemi nasıl çalışıyor?",
    answer: "Online koçluk sistemimiz, modern teknoloji araçlarını kullanarak yüz yüze eğitimin tüm avantajlarını dijital ortama taşıyor. Görüntülü görüşmeler, anlık mesajlaşma ve özel çalışma materyalleri ile kesintisiz bir öğrenme deneyimi sunuyoruz."
  },
  {
    question: "Koçumla ne sıklıkta görüşebilirim?",
    answer: "Koçunuzla haftalık düzenli görüşmeler yapabilirsiniz. Görüşme sıklığı ve süresi, ihtiyaçlarınıza ve hedeflerinize göre ayarlanabilir. Ayrıca acil durumlar için koçunuza mesaj yoluyla her zaman ulaşabilirsiniz."
  },
  {
    question: "Ödeme planları nasıl işliyor?",
    answer: "Aylık ve dönemlik ödeme seçeneklerimiz bulunmaktadır. Dönemlik planlarda indirim avantajı sunuyoruz. Ödemeler güvenli ödeme sistemleri üzerinden gerçekleştiriliyor ve her öğrenciye özel fatura düzenleniyor."
  },
  {
    question: "Deneme süreci var mı?",
    answer: "İlk görüşmenizde koçunuzla tanışıp sistemimizi deneyimleme fırsatı bulacaksınız. Eğer herhangi bir nedenden memnun kalmazsanız, ilk 7 gün içinde iade garantisi sunuyoruz."
  },
  {
    question: "Koçumu değiştirebilir miyim?",
    answer: "Evet, eğer koçunuzla uyum sorunu yaşarsanız veya farklı bir koçla çalışmak isterseniz değişiklik talebinde bulunabilirsiniz. Amacımız size en uygun koçla çalışmanızı sağlamaktır."
  },
  {
    question: "YKS hazırlık sürecinde başka ne gibi destekler sunuyorsunuz?",
    answer: "Koçluk hizmetimizin yanı sıra, düzenli motivasyon desteği, özel çalışma materyalleri, deneme sınavları analizi ve hedef belirleme konularında da destek sağlıyoruz. Ayrıca stres yönetimi ve zaman planlaması konularında da rehberlik sunuyoruz."
  }
];

export const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-brand-primary mb-4">
            Sıkça Sorulan Sorular
          </h2>
          <p className="text-lg text-brand-primary/70 max-w-2xl mx-auto">
            Kampüs Mentorluk hakkında merak ettiğiniz tüm soruların cevapları burada
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="mb-4"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-6 bg-white rounded-lg shadow-sm hover:shadow-md transition-all duration-200"
              >
                <span className="text-left text-lg font-medium text-brand-primary">
                  {faq.question}
                </span>
                <ChevronDown
                  className={`w-5 h-5 text-gray-500 transition-transform duration-200 ${openIndex === index ? "transform rotate-180" : ""
                    }`}
                />
              </button>
              <AnimatePresence>
                {openIndex === index && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.2 }}
                    className="overflow-hidden"
                  >
                    <div className="p-6 bg-white/50 rounded-b-lg shadow-inner">
                      <p className="text-brand-primary/70 text-base leading-relaxed">
                        {faq.answer}
                      </p>
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}; 